import { useMutation } from '@tanstack/vue-query';
import type { User } from '~/types';

// Saves an E.164 phone string on the signed-in user (PATCH /api/user/:id
// validates + normalises it). Used by the portal's required phone prompt.
export const useUpdatePhone = () => {
  const authStore = useAuthStore();

  return useMutation({
    mutationFn: (phone: string) =>
      $fetch<User>(`/api/user/${authStore.user?.id}`, {
        method: 'PATCH',
        body: { phone },
        headers: { Authorization: `Bearer ${authStore.token}` },
      }),
    onSuccess: (user) => {
      // Merge only the phone — the PATCH echoes the raw DB row.
      if (authStore.user) authStore.updateUser({ ...authStore.user, phone: user.phone });
    },
    onError: (error) => {
      useErrorHandler().catchErrors(error);
    },
  });
};
